import { FEATURE_FLAGS } from '@tgbot/app/constants/feature-flags.constant';
import { RoutePath } from '@tgbot/app/enums/route-path.enum';
import { RouteLink } from '@tgbot/app/models/route-link.model';

import { UserGroup } from '../auth/models/user.model';

export const ROUTE_PATHS: RouteLink[] = [
  {
    link: RoutePath.TelegramAccountList,
    icon: 'chat',
    name: 'Telegram',
    userGroups: [UserGroup.AccessManager, UserGroup.Admin, UserGroup.Manager],
    subRoutes: [
      {
        link: RoutePath.AccountCreation,
        name: 'Account creation',
        userGroups: [UserGroup.AccessManager, UserGroup.Admin],
      },
      {
        link: RoutePath.AccountManagement,
        name: 'Account management',
        userGroups: [UserGroup.AccessManager, UserGroup.Admin, UserGroup.Manager],
      },
      {
        link: RoutePath.AccountAssignment,
        name: 'Account assignment',
        userGroups: [UserGroup.AccessManager, UserGroup.Admin],
      },
      {
        link: RoutePath.MassMessaging,
        name: 'Mass messaging',
        userGroups: [UserGroup.Manager, UserGroup.Admin],
        featureFlag: FEATURE_FLAGS.massMessaging,
      },
    ],
  },
] as const;
